import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { AccessService } from '../services/access.service';
import { FeatureService } from '../services/feature.service';

export const sigmaAccessGuard: CanActivateFn = () => {
  const accessService = inject(AccessService);
  const featureService = inject(FeatureService);
  const router = inject(Router);

  // Explicitly disabled feature always blocks, regardless of access
  if (featureService.isSigmaDashboardActive() === false) return router.createUrlTree(['/']);

  // Feature is active or not yet loaded — fall through to access check only
  const accessValue = accessService.isSigmaUser();

  if (accessValue === true) return true;
  if (accessValue === false) return router.createUrlTree(['/']);

  return accessService.checkAccess().pipe(
    map(result => result.sigmaUsers === true ? true : router.createUrlTree(['/']))
  );
};
